import { createReducer, on } from '@ngrx/store';
import * as fromCampusActions from '../actions/campus.action';
export const featureKey = 'campus';

export interface State {
    campus: {
        data: Array<any>,
        isLoaded: Boolean
    };
    buildings: {
        data: Array<any>,
        isLoaded: Boolean
    };
    rooms: {
        data: Array<any>,
        isLoaded: Boolean
    };
    college: {
        data: Array<any>,
        isLoaded: Boolean
    };
    course: {
        data: Array<any>,
        isLoaded: Boolean
    };
    department: {
        data: Array<any>,
        isLoaded: Boolean
    };
}

export const initialState: State = {
    campus: {
        data: [],
        isLoaded: false
    },
    buildings: {
        data: [],
        isLoaded: false
    },
    rooms: {
        data: [],
        isLoaded: false
    },
    college: {
        data: [],
        isLoaded: false
    },
    course: {
        data: [],
        isLoaded: false
    },
    department: {
        data: [],
        isLoaded: false
    },
}

export const reducer = createReducer(
    initialState,
    on(fromCampusActions.getCampusSuccess, (state: State, props: any) => ({
        ...state,
        campus: { data: props.data, isLoaded: true },
    })),
    on(fromCampusActions.getBuildingsSuccess, (state: State, props: any) => ({
        ...state,
        buildings: { data: props.data, isLoaded: true },
    })),
    on(fromCampusActions.getRoomsSuccess, (state: State, props: any) => ({
        ...state,
        rooms: { data: props.data, isLoaded: true },
    })),
    on(fromCampusActions.getCollegesSuccess, (state: State, props: any) => ({
        ...state,
        college: { data: props.data, isLoaded: true },
    })),
    on(fromCampusActions.getCoursesSuccess, (state: State, props: any) => ({
        ...state,
        course: { data: props.data, isLoaded: true },
    })),
    on(fromCampusActions.getDepartmentsSuccess, (state: State, props: any) => ({
        ...state,
        department: { data: props.data, isLoaded: true },
    })),
    // on(fromAuthActions.autoLogout, (state: State, props) => initialState),
);